import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './NotFoundHandler.css';

import StringRes from './component/StringResources';
import NotFound from './component/NotFound';
import Topbar from './component/Topbar';
import NavbarElement from './component/Navbar';
import Footer from './component/Footer';

function NotFoundHandler() {
  const [onTop, setOnTop] = useState(true);
  useEffect(() => {
    const onScroll = () => setOnTop(window.scrollY <= 44);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const [pageWidth, setPageWidth] = useState(1280);
  useEffect(() => {
    setPageWidth(window.innerWidth);
    const onResize = () => setPageWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const lang = 'lt';
  const strings = StringRes(lang);

  return (
    <div className='flex-wrapper'>
      <Helmet>
        <title>404 – Puslapis nerastas | Geltonas Traliukas</title>
        <meta name="description" content="Puslapis nerastas. Grįžkite į pradinį puslapį arba susisiekite su mumis." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Topbar strings={strings} pageWidth={pageWidth} />
      <NavbarElement strings={strings} notFound={true} pageWidth={pageWidth} onTop={onTop} lang={lang} />
      <main>
        <NotFound strings={strings} onTop={onTop} />
      </main>
      <Footer />
    </div>
  );
}

export default NotFoundHandler;
